
export default {
  init() {
    // JavaScript to be fired on the locals archive
    const ajax_url = window.sage.ajax_url || false;
    $(document).ready( function() {
      $(".reminder-mail-locals").click( function(e) {
         e.preventDefault(); 
         $("#reminder-response").empty();
         $.ajax({
            type : "post",
            dataType : "json",
            url : ajax_url,
            data : {action: 'send_reminder_email'},
            beforeSend: function() {
               $('.reminder-mail-locals .ajax-send').hide();
               $('.reminder-mail-locals .ajax-sync').show();
            },
            complete: function() {
               $('.reminder-mail-locals .ajax-send').show();
               $('.reminder-mail-locals .ajax-sync').hide();
            },
            success: function(response) {
               $("#reminder-response").html(response.html);
            },
         });
      });
    });    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/debugging.js